import {Stack, styled} from '@mui/material';

const StyledStack = styled(Stack)`
	position: sticky;
	top: 80px;
	z-index: 1;

	${({theme}) => theme.breakpoints.down('sm')} {
		top: 64px;
	}
`;

export {StyledStack};
